module.exports = __webpack_public_path__ + "static/img/sctm.1c558f80.png";